var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceIcon = function SvgDeviceIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1645 20.2565H27.9528V9.38596H34.1645M35.7175 6.28009H26.3999C25.988 6.28009 25.593 6.44371 25.3018 6.73494C25.0105 7.02617 24.8469 7.42116 24.8469 7.83303V23.3624C24.8469 23.7742 25.0105 24.1692 25.3018 24.4605C25.593 24.7517 25.988 24.9153 26.3999 24.9153H35.7175C36.1293 24.9153 36.5243 24.7517 36.8156 24.4605C37.1068 24.1692 37.2704 23.7742 37.2704 23.3624V7.83303C37.2704 7.42116 37.1068 7.02617 36.8156 6.73494C36.5243 6.44371 36.1293 6.28009 35.7175 6.28009ZM6.21173 3.17423H34.1645V0.0683594H6.21173C5.38801 0.0683594 4.59802 0.395584 4.01555 0.978047C3.43309 1.56051 3.10587 2.3505 3.10587 3.17423V20.2565H0V24.9153H21.7411V20.2565H6.21173V3.17423Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/device-icon.7d11cdf08dc4bc71cd46fddc3ecf28e1.svg";